// extracted by mini-css-extract-plugin
module.exports = {"container":"_2E_uKt","slideBottom":"_2NpF2I","notification":"_3VLvXG","shine-lines":"_2aBCeF"};